<template>
  <div class="straddle">
    <!-- “straddle”限制css于本页面 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></sirui-search>
    <div class="main-content">
      <vxe-grid
        border
        highlight-hover-row
        highlight-current-row
        resizable
        align="left"
        size="mini"
        show-overflow
        ref="table"
        :auto-resize="true"
        :data="tableData"
        :columns="columnList"
        @cell-click="rowClick"
        column-min-width="150"
        :max-height="$store.state.app.tableHeight"
      >
        <!-- <vxe-table-column
          v-for="(item,index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title"
          :edit-render="item.editRender"
        >
        </vxe-table-column> -->
      </vxe-grid>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          ref="page"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-count="page.pages"
          :page-size="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>

      <!-- tab页 -->
      <el-tabs class="batchTabs" type="border-card">
        <!-- 持仓信息 -->
        <el-tab-pane :label="$t('futuresStrategy.collapseTitle.holdInfo')">
          <straddle-hold ref="straddleHold" :heightNew="heightNew" :ptcombiRow="this.ptcombiRow" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  import API from '@/api/futuresStrategy/index';
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import tableMixins from '@/common/mixins/table.js';
  import StraddleHold from './components/straddleHold'; // 持仓信息
  export default {
    name: 'straddleList',
    mixins: [tableMixins],
    components: {
      SiruiSearch,
      StraddleHold,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          //   策略编号
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.ptcombiNo'),
            prop: 'ptcombiNo',
            type: 'input',
            clearable: true,
          },
          //   业务部门
          {
            prop: 'branchName',
            name: this.$t('futuresStrategy.futuresStrategyList.search.departmentName'),
            type: 'input',
            placeholder: this.$t('futuresStrategy.futuresStrategyList.placeholder.departmentCode'),
            clearable: true,
          },
          //策略名称
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.combiName'),
            prop: 'combiName',
            type: 'input',
            clearable: true,
          },
          //项目名称
          {
            name: this.$t('futuresStrategy.futuresStrategyList.search.projectName'),
            prop: 'productName',
            type: 'input',
            clearable: true,
          },
        ];
      },
      columnListDefault() {
        return [
          //序号
          //{ type: "checkbox", visible: true, width: "50", fixed: "left" },
          { type: 'seq', visible: true, width: '50', fixed: 'left', title: this.$t('table.index') },
          //项目名称
          {
            field: 'productName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.projectName'),
            visible: true,
          },
          //策略编号
          {
            field: 'ptcombiNo',
            title: this.$t('futuresStrategy.futuresStrategyList.table.ptcombiNo'),
            visible: true,
            width: 210,
          },
          //策略名称
          {
            field: 'combiName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.combiName'),
            visible: true,
          },
          //策略模式
          {
            field: 'exchangeTypeMode',
            title: this.$t('futuresStrategy.futuresStrategyList.table.exchangeTypeMode'),
            visible: true,
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('strategy_model'),
              props: {
                clearable: true,
              },
            },
          },
          //交易日期
          {
            field: 'initDate',
            title: this.$t('futuresStrategy.futuresStrategyList.table.initDate'),
            visible: true,
            width: 80,
          },
          //业务部门
          {
            field: 'branchName',
            title: this.$t('futuresStrategy.futuresStrategyList.table.departmentName'),
            visible: true,
            width: 150,
          },
          //合约代码
          {
            field: 'futuCode',
            title: this.$t('futuresStrategy.futuresStrategyList.table.futuCode'),
            visible: true,
          },
          //开仓价差
          {
            field: 'openPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.openPrice'),
            visible: true,
          },
          //市场价差
          {
            field: 'marketPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.marketPrice'),
            visible: true,
          },
          //持仓价差
          {
            field: 'holdPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.holdPrice'),
            visible: true,
          },
          //平仓价差
          {
            field: 'dropPrice',
            title: this.$t('futuresStrategy.futuresStrategyList.table.dropPrice'),
            visible: true,
          },
          //浮动盈亏
          {
            field: 'holdIncomeFloat',
            title: this.$t('futuresStrategy.futuresStrategyList.table.holdIncomeFloat'),
            visible: true,
          },
          //实现盈亏
          {
            field: 'actualIncome',
            title: this.$t('futuresStrategy.futuresStrategyList.table.actualIncome'),
            visible: true,
          },
          //总盈亏
          {
            field: 'incomeSum',
            title: this.$t('futuresStrategy.futuresStrategyList.table.incomeSum'),
            visible: true,
          },
          //净值
          {
            field: 'netValue',
            title: this.$t('futuresStrategy.futuresStrategyList.table.netValue'),
            visible: true,
          },
          //敞口数量
          {
            field: 'exposureAmount',
            title: this.$t('futuresStrategy.futuresStrategyList.table.exposureAmount'),
            visible: true,
          },
          //敞口金额
          {
            field: 'exposureBalance',
            title: this.$t('futuresStrategy.futuresStrategyList.table.exposureBalance'),
            visible: true,
          },
        ];
      },
    },
    data() {
      return {
        heightNew: 0,
        loading: false,
        query: {
          ptcombiNo: null, //策略编号
          branchNo: null, //业务部门
          branchName: null, //业务部门
          combiName: null, //策略名称
          prodAccount: null, //产品账户
          productName: null, //产品名称-项目名称
          strategyCategory: '2', //1-基差策略，2-套利策略，3-单边策略
        },
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        }, //
        tableData: [], //列表数据
        ptcombiRow: null,
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
      this.heightNew = document.body.clientHeight - 300 + 'px';
    },
    methods: {
      //获取table数据
      getData() {
        const params = JSON.parse(JSON.stringify(this.query));
        params.pageSize = this.page.pageSize;
        params.pageNum = this.page.pageNum;
        this.load = true;
        this.$axios.post(API.LIST_PROCOMBIS_BY_PAGE, params).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          }
        });
      },

      //点击表格记录正在编辑哪一行
      rowClick(row) {
        this.ptcombiRow = row;
        this.$nextTick(() => {
          this.$refs.straddleHold.getData();
        });
      },
      searchBtnClick() {
        this.resetBtnClick();
      },
      resetBtnClick() {
        // 重置
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.multipleSelection = [];
        this.$refs.table.clearCheckboxReserve();
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
    },
  };
</script>

<style scoped lang="scss">
  .batchTabs {
    ::v-deep .el-tabs__item.is-active {
      color: #00b400;
    }
    ::v-deep .el-tabs__item:not(.is-disabled):hover {
      color: #00b400;
    }
  }
</style>
